import { FC, ReactNode } from 'react'
import { IconPaths, KTSVG } from '_metronic/helpers'

type Tom = 'atencao' | 'erro' | 'neutro'

type Props = {
  tom: Tom
  titulo: string
  /** Uma linha por item — usado nos erros de validação (422), item a item. */
  itens?: string[]
  children?: ReactNode
}

// alert-<tipo> do Metronic pinta o texto com a cor-base (abaixo de AA); text-<tipo>-emphasis
// troca pelo par legível nos dois temas.
const CLASSES: Record<Tom, string> = {
  atencao: 'alert-warning text-warning-emphasis',
  erro: 'alert-danger text-danger-emphasis',
  neutro: 'bg-gray-100 border-gray-400 text-gray-900',
}

const ICONES: Record<Tom, IconPaths> = {
  atencao: IconPaths.Warning,
  erro: IconPaths.OctagonX,
  neutro: IconPaths.Info,
}

/**
 * Aviso da agenda, junto do campo/da grade que o gerou — nunca em toast.
 *
 * Mesmo papel do `escalas/components/ErrosVinculos.tsx`: lista item a item o
 * que o backend recusou, em vez de silenciar.
 *
 * `role='alert'` nos tons de atenção e erro, `role='status'` no neutro: o
 * neutro é orientação permanente, não interrompe a leitura.
 */
export const AvisoAgenda: FC<Props> = ({ tom, titulo, itens, children }) => {
  if (!children && !itens?.length) return null

  return (
    <div
      className={`alert d-flex align-items-start gap-3 py-3 px-4 mb-5 ${CLASSES[tom]}`}
      role={tom === 'neutro' ? 'status' : 'alert'}
    >
      <KTSVG path={ICONES[tom]} className='svg-icon-em fs-5 lh-base text-reset' ariaHidden />
      <div>
        <strong className='d-block fw-bold mb-1'>{titulo}</strong>
        {children}
        {!!itens?.length && (
          <ul className='mb-0 ps-4'>
            {itens.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
